import { HttpErrorDto, HttpSuccessDto } from "@common/dto/http";
import { PanelFolderCreateDto } from "@common/dto/panel/folder-create-dto";
import { PanelListDto } from "@common/dto/panel/panel-list-dto";
import client from "@common/utils/rest";
import { PanelFolderListDto } from "../dto/panel-folder-list-dto";
import { PanelCreateDto } from "../dto/panel/create-dto";
import { PanelGetDto } from "../dto/panel/get-dto";
import { PanelUpdateDto } from "../dto/panel/update-dto";
import { I18n } from "react-redux-i18n";

const getUrl = (path: string | number) => {
  return `api/testsResults/panels/${path}`;
};

export const getPanelsFolders = (): Promise<Array<PanelFolderListDto>> => {
  return client({
    method: 'GET',
    path: getUrl('0/folders'),
  }).then((x: HttpSuccessDto<Array<PanelFolderListDto>>) => {
    return x.entity;
  });
};

export const getPanels = (folderId: number): Promise<Array<PanelListDto>> => {
  return client({
    path: getUrl(`${folderId}/formats`),
    method: 'GET',
  }).then((response: HttpSuccessDto<Array<PanelListDto>>) => {
    return response.entity;
  });
};

export const getPanelsFlat = async (): Promise<Array<PanelListDto>> => {
  return client({
    path: getUrl('getallformats'),
    method: 'GET',
  }).then((response: HttpSuccessDto<Array<PanelListDto>>) => {
    return response.entity;
  });
};

export const createPanelFolder = async (data: PanelFolderCreateDto): Promise<void> => {
  await client({
    entity: {
      ...data,
      parentid: data.parentid || 0
    },
    method: 'POST',
    path: getUrl('createfolder'),
  }).then((res: HttpSuccessDto<{ id: -1 } | undefined>) => {
    if (res.entity && res.entity.id === -1) {
      throw {
        entity: I18n.t('Folder name already exists'),
      };
    }
  });
};

export const deletePanelFolder = async (folderId: number): Promise<void> => {
  return client({
    method: 'POST',
    path: getUrl(`${folderId}/deletefolder`),
  });
};

export const deletePanel = async (panelId: number): Promise<void> => {
  await client({
    method: 'POST',
    path: getUrl(`${panelId}/deletepanel`),
  });
};

export const updatePanel = async (panel: PanelUpdateDto): Promise<void> => {
  await client({
    method: 'POST',
    path: getUrl('saveformat'),
    entity: panel,
  }).then((res: HttpSuccessDto<{ id: -1 | -2; errorcode: -1 | -2 } | undefined>) => {
    if (res.entity && (res.entity.errorcode === -1 || res.entity.id === -1)) {
      throw {
        entity: I18n.t('Format name already exists'),
      };
    }

    if (res.entity && (res.entity.errorcode === -2 || res.entity.id === -2)) {
      throw {
        entity: I18n.t('Test name already exists'),
      };
    }
  });
};

export const createPanel = async (panel: PanelCreateDto): Promise<HttpErrorDto | void> => {
  const { genes, ...otherPanel } = panel;

  return client({
    method: 'POST',
    path: getUrl('saveformat'),
    entity: {
      id: 0,
      genes: genes.map((x) => ({
        ...x,
        id: 0,
      })),
      ...otherPanel,
    },
  }).then((res: HttpSuccessDto<{ id: -1 | -2; errorcode: -1 | -2 } | undefined>) => {
    if (res.entity && (res.entity.errorcode === -1 || res.entity.id === -1)) {
      throw {
        entity: I18n.t('Format name already exists'),
      };
    }

    if (res.entity && (res.entity.errorcode === -2 || res.entity.id === -2)) {
      throw {
        entity: I18n.t('Test name already exists'),
      };
    }
  });
};

export const overwritePanel = async (panel: PanelCreateDto): Promise<HttpErrorDto | void> => {
  const { genes, ...otherPanel } = panel;

  return client({
    method: 'POST',
    path: getUrl('overwriteformat'),
    entity: {
      id: 0,
      genes: genes.map((x) => ({
        ...x,
        id: 0,
      })),
      ...otherPanel,
    },
  }).then((res: HttpSuccessDto<{ id: -1 | -2; errorcode: -1 | -2 } | undefined>) => {
    if (res.entity && (res.entity.errorcode === -1 || res.entity.id === -1)) {
      throw {
        entity: I18n.t('Format name already exists'),
      };
    }

    if (res.entity && (res.entity.errorcode === -2 || res.entity.id === -2)) {
      throw {
        entity: I18n.t('Test name already exists'),
      };
    }
  });;
};

export const getPanelFormat = (panelId: number) => {  
  return client({
    path: getUrl(`${panelId}/format`),
    method: 'GET',
  }).then((response: HttpSuccessDto<PanelGetDto>) => {
    return response.entity;
  });
};

export const doesPanelNameExist = (folderId: string | number, name: string) => {
  return client({
    path: getUrl('checkpanelnameexists'),
    params: {
      folderid: folderId,
      name,
    },
    method: 'GET',
  }).then((response: HttpSuccessDto<boolean>) => {
    return response.entity;
  });
};
